import React, { useEffect } from 'react';
import Modal from "react-modal";
import closeBlack from "../assets/images/close-black.png";

const guestCheckoutModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    padding: 0,
    border: 0,
    background: "none",
    overflow: "visible",
    transform: "translate(-50%, -50%)",
  },
  overlay: {
    backgroundColor: "rgba(18, 18, 18, 0.38)",
    zIndex: 9999,
  },
};

function GuestCheckoutDialog({
  open,
  onClose,
  onLogin,
  onRegister,
  title,
  message,
  loginLabel,
  registerLabel,
}) {
  useEffect(() => {
    Modal.setAppElement("#root");
  }, []);

  return (
    <Modal
      isOpen={open}
      onRequestClose={onClose}
      shouldCloseOnOverlayClick
      style={guestCheckoutModalStyles}
      contentLabel={title}
      id="custom-popup-content"
    >
      <div className="contentModal guest-checkout-modal">
        <div className="modal">
          <button onClick={onClose} className="close-btn guest-checkout-modal__close">
            <img src={closeBlack} alt="Fermer" />
          </button>
          <h2>{title}</h2>
          <p className="modal-text2 text-message">{message}</p>
          <div className="modal-button-container">
            <button className="modal-cancel-button" onClick={onRegister}>
              {registerLabel}
            </button>
            <button className="modal-ok-button" onClick={onLogin}>
              {loginLabel}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default GuestCheckoutDialog;
